<template>
  <div id="app" class="container-fluid">
    <!-- Header -->
    <full_dental_head :visit_id="visit_id" />

    <!-- Main Content - Dental Charting Module -->
    <div class="main-content">
      <div>
        <!-- Tooth Chart Section -->
        <div style="padding: 0; margin: 0" class="card">
          <div class="card-header">
            <h3><i class="fas fa-teeth"></i> Tooth Chart</h3>
            <div class="notation-selector">
              <label
                >Notation System:
                <span
                  style="
                    background-color: white;
                    font-size: 1.2em;
                    padding: 0.5em;
                  "
                  >FDI (ISO)</span
                ></label
              >
              <!-- <select v-model="selectedNotation">
                <option value="universal">Universal</option>
                <option value="fdi">FDI (ISO)</option>
                <option value="palmer">Palmer</option>
              </select> -->
            </div>
          </div>
          <div class="card-body">
            <!-- Tooth Chart Visual Placeholder -->
            <div class="tooth-chart-visual">
              <div class="jaw-section maxillary">
                <h4>Maxillary (Upper Jaw)</h4>
                <div class="teeth-grid">
                  <!-- Teeth 1-16 will go here -->
                  <div
                    v-for="tooth in dental_formular.filter(
                      (t) => t.jaw === 'Upper'
                    )"
                    :key="tooth.number"
                    class="tooth-item"
                    :class="getToothClass(tooth.tooth_status)"
                    @click="show_tooth_input_modal(tooth.tooth_id)"
                  >
                    <div class="tooth-number">
                      {{ getToothNotation(tooth.fdi_iso_number) }}
                    </div>
                    <div class="tooth-name">
                      {{ tooth.tooth_name }}
                    </div>
                    <div class="tooth-status">
                      {{ tooth.tooth_status ?? "---" }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="jaw-section mandibular">
                <h4>Mandibular (Lower Jaw)</h4>
                <div class="teeth-grid">
                  <!-- Teeth 17-32 will go here -->
                  <div
                    v-for="tooth in dental_formular.filter(
                      (t) => t.jaw === 'Lower'
                    )"
                    :key="tooth.number"
                    class="tooth-item"
                    :class="getToothClass(tooth.tooth_status)"
                    @click="show_tooth_input_modal(tooth.tooth_id)"
                  >
                    <div class="tooth-number">
                      {{ getToothNotation(tooth.fdi_iso_number) }}
                    </div>
                    <div class="tooth-name">
                      {{ tooth.tooth_name }}
                    </div>
                    <div class="tooth-status">
                      {{ tooth.tooth_status ?? "---" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <individual_tooth_chart_input
    :toothId="tooth_id_current"
    :visit_id="visit_id"
    @close-tooth-input="close_tooth_input_modal"
    v-if="show_individual_tooth_input"
  />

  <individual_tooth_chart :tooth_id="31" v-if="show_individual_tooth" />
</template>

<script>
import individual_tooth_chart_input from "./individual_tooth_chart_input.vue";
import individual_tooth_chart from "./individual_tooth_chart.vue";
import full_dental_head from "./full_dental_head.vue";
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "DentalCharting",
  data() {
    return {
      show_individual_tooth_input: false,
      show_individual_tooth: false,
      visit_id: this.$route.params.visit_id,
      selectedNotation: "fdi",
      dental_formular: [],
      tooth_id_current: "",
    };
  },
  components: {
    full_dental_head,
    individual_tooth_chart_input,
    individual_tooth_chart,
  },
  methods: {
    close_tooth_input_modal() {
      this.tooth_id_current = "";
      this.show_individual_tooth_input = false;
    },
    show_tooth_input_modal(tid) {
      console.log(tid);

      this.tooth_id_current = tid;
      this.show_individual_tooth_input = true;
    },
    getToothClass(status) {
      const classMap = {
        sound: "tooth-sound",
        caries: "tooth-caries",
        filled: "tooth-filled",
        missing: "tooth-missing",
        fractured: "tooth-fractured",
        impacted: "tooth-impacted",
        root_stump: "tooth-root",
      };
      return classMap[status] || "tooth-sound";
    },
    async get_chart() {
      const url = "getPatientDentalChart/" + this.$route.params.visit_id;
      const body = {};
      const res = await generalApiRequest(url, "GET", body, 1);
      this.dental_formular = res.data;
      console.log(res);
    },
    getToothNotation(number) {
      if (this.selectedNotation === "universal") {
        return number;
      } else if (this.selectedNotation === "fdi") {
        // FDI notation uses two digits
        return number < 10 ? `0${number}` : number;
      } else {
        // Palmer notation
        if (number <= 8) return `${number}┘`;
        if (number <= 16) return `└${number - 8}`;
        if (number <= 24) return `${number - 16}┐`;
        return `┌${number - 24}`;
      }
    },
  },
  mounted() {
    this.get_chart();
  },
};
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 20px;
  border-bottom: 2px solid #dee2e6;
}

.card-header h3 {
  margin: 0;
  color: #495057;
  font-size: 20px;
}

.notation-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.notation-selector select {
  padding: 8px 15px;
  border: 2px solid #dee2e6;
  border-radius: 6px;
  background: white;
  font-weight: 600;
}

.tooth-chart-visual {
  margin: 30px 0;
}

.jaw-section {
  margin-bottom: 40px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.jaw-section h4 {
  color: #495057;
  margin-bottom: 20px;
  text-align: center;
  font-size: 18px;
}

.teeth-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 15px;
}

.tooth-item {
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.tooth-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.tooth-number {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 5px;
}

.tooth-name {
  font-size: 0.85rem;
  color: #555;
  margin: 2px 0;
}

.tooth-status {
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
}

/* Tooth Status Colors */
.tooth-sound {
  background: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.tooth-caries {
  background: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.tooth-filled {
  background: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.tooth-missing {
  background: #e9ecef;
  border-color: #dee2e6;
  color: #6c757d;
  text-decoration: line-through;
}

.tooth-fractured {
  background: #ff6b6b;
  border-color: #ff5252;
  color: white;
}

.tooth-impacted {
  background: #5c7cfa;
  border-color: #4c6ef5;
  color: white;
}

.tooth-root {
  background: #795548;
  border-color: #6d4c41;
  color: white;
}

@media (max-width: 768px) {
  .teeth-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 576px) {
  .teeth-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
